require('./virtualMachines.style.scss');
const { permissions } = require('../../constants/permissions');
const VirtualMachine = require('../../model/VirtualMachine');
const VM_PROTECTED_DELETED = 'PROTECTED_DELETED';
let tagsUnwatch;
class VirtualMachinesController {
    constructor(
        $scope,
        $timeout,
        $element,
        $window,
        $filter,
        $stateParams,
        $state,
        $q,
        $rootScope,
        crudService,
        utilsService,
        dialogService,
        notificationService,
        virtualMachinesPersistence,
        storageService,
        sharedPersistenceService,
        recoverFileService,
        iamPersistenceService
    ) {
        this._$scope = $scope;
        this.$element = $element;
        this.$window = $window;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$q = $q;
        this.$rootScope = $rootScope;
        this.crudService = crudService;
        this.utilsService = utilsService;
        this.dialogService = dialogService;
        this.iamPersistenceService = iamPersistenceService;
        this.notificationService = notificationService;
        this.storageService = storageService;
        this.persistence = virtualMachinesPersistence;
        this.isBackupAdmin = utilsService.isBackUpAdmin();
        this.dateFilter = $filter('localizeDate');
        this.detailsPermissions = permissions.VM_DETAILS;
        this.sharedPersistence = sharedPersistenceService;
        this.REST_ENDPOINTS = this.sharedPersistence.getRestEndpoints();
        this.recoverFileService = recoverFileService;
        this.expandedGroups = {};
        this.isMini = false;
        this.configVirtualMachinesTable();
        this.clusterCounter = this.sharedPersistence.clusterRenderCounter;
        this.pagination = {};
        this.chosenVirtualMachines = [];
        this.multiSelectTooltipList = [
            {
                title: this.$filter('translate')('common.tooltip.headerSelection.label'),
                descList: [
                    this.$filter('translate')('vm.ctxGrid.multiSelect.checkBox.header.tooltip.headerSelection.info1'),
                    this.$filter('translate')('vm.ctxGrid.multiSelect.checkBox.header.tooltip.headerSelection.info2'),
                ],
            },
            {
                title: this.$filter('translate')('common.tooltip.bodySelection.label'),
                descList: [
                    this.$filter('translate')('vm.ctxGrid.multiSelect.checkBox.header.tooltip.bodySelection.info1'),
                    this.$filter('translate')('vm.ctxGrid.multiSelect.checkBox.header.tooltip.bodySelection.info2'),
                ],
            },
        ];
        this._$scope.$on('virtual_machines.refresh', () => {
            this.refreshVirtualMachines();
            this.filterFlag++;
            this.backupFilterFlag++;
        });
        this._$scope.$on('sub-changed', () => {
            this.stateParamsFilterInit().then(() => {
                this.chosenVirtualMachinesOrig = [];
                this.selectedVirtualMachine = null;
                this.shownDetailsIndex = null;
                this.refresh(true);
                this.filterFlag++;
            });
            this.persistence.initDropdownFilters();
        });
        this._$scope.$on('virtualMachine_credentials.refresh', (test, data) => {
            this.persistence.getVirtualMachine(data.name).then((resp) => {
                if (resp[0]) {
                    let virtualMachine = this.virtualMachines.find((item) => item.name === data.name);
                    virtualMachine.discoveryStatus = resp[0].discoveryStatus;
                    virtualMachine.credential = resp[0].credential;
                    virtualMachine.credentialGroupUuid = resp[0].credentialGroupUuid;
                }
            });
        });
        this._$scope.$watch(
            () => this.chosenVirtualMachinesOrig,
            (chosenVirtualMachines) => {
                if (chosenVirtualMachines) {
                    this.setChosenVirtualMachines(chosenVirtualMachines);
                }
            }
        );
    }
    $onInit() {
        this.virtualMachines = [];
        this.allVms = [];
        this.chosenVirtualMachinesOrig = [];
        this.filterFlag = 0;
        this.backupFilterFlag = 0;
        this.stateParamsFilterInit().then(() => {
            this.refresh();
            this.filterFlag++;
            this.backupFilterFlag++;
        });
        this.persistence.initDropdownFilters();
        this.flrLabel = this.$filter('translate')('vm.subTable.detail.actionRestoreFiles.label');
        this.restoreVirtualMachineLabel = this.$filter('translate')('vm.subTable.detail.actionRestoreVM.label');
        this._$scope.$watch(
            () => this.sharedPersistence.clusterRenderCounter,
            (clusterRenderCounter) => {
                if (this.clusterCounter === clusterRenderCounter) return;
                this.$timeout(() => this.refresh(true), 0);
            }
        );
        this.destroyBroadcastCatcher = this.$rootScope.$on('subscriptionChanged', () => {
            this.refresh();
        });
    }
    $onDestroy() {
        tagsUnwatch = undefined;
        this.destroyBroadcastCatcher();
    }
    setChosenVirtualMachines(selectedVirtualMachines) {
        let array = [];
        selectedVirtualMachines.forEach((virtualMachine) => {
            array.push(virtualMachine);
        });
        // set array with unique values
        this.chosenVirtualMachines = [...new Set(array)];
    }
    stateParamsFilterInit() {
        if (this.persistence.backupFilters) {
            let timeFilter = this.persistence.backupFilters.filter((item) => item.filterKey === 'created')[0];
            if (timeFilter) timeFilter.datetimeLocaleFormat = this.persistence.datetimeLocaleFormat;
        }
        return this.$q((resolve) => {
            if (
                !this.$stateParams.protectionFilter &&
                !this.$stateParams.compliantFilter &&
                !this.$stateParams.policyFilter
            )
                return resolve();
            this.persistence.clearFilter();
            if (this.$stateParams.protectionFilter) {
                let protectionFilter = this.persistence.filters.filter(
                    (item) => item.filterKey === VirtualMachine.getStatusKey()
                )[0];
                protectionFilter.setOptionByValue(this.$stateParams.protectionFilter);
            }
            if (this.$stateParams.compliantFilter) {
                let compliantFilter = this.persistence.filters.filter(
                    (item) => item.filterKey === VirtualMachine.getCompliancyKey()
                )[0];
                compliantFilter.setOptionByValue(this.$stateParams.compliantFilter);
            }
            if (this.$stateParams.policyFilter) {
                let policyFilter = this.persistence.filters.filter(
                    (item) => item.filterKey === VirtualMachine.getPolicyKey()
                )[0];
                this.persistence.getAllProtectionGroups().then(
                    (policies) => {
                        policyFilter.options = this.persistence.updateFilterOptions(policies, policyFilter);
                        policyFilter.setOptionByValue(this.$stateParams.policyFilter);
                        resolve();
                    },
                    (err) => resolve()
                );
            } else {
                resolve();
            }
        });
    }
    backup() {
        let message = '';
        let count = this.$filter('translate')('vm.backup.machines');
        if (this.chosenVirtualMachines.length < 2) {
            message = this.chosenVirtualMachines[0].name;
            count = this.$filter('translate')('vm.backup.machine');
        } else if (this.chosenVirtualMachines.length < 3) {
            message =
                this.chosenVirtualMachines[0].name +
                ' ' +
                this.$filter('translate')('vm.backup.dual.select') +
                ' ' +
                this.chosenVirtualMachines[1].name;
        } else {
            message = this.chosenVirtualMachines.length;
        }
        this.dialogService
            .showYesNo(
                this.$filter('translate')('vm.backup.message') + ' ' + message + ' ' + count,
                this.$filter('translate')('vm.toolbar.backup.label'),
                null,
                'virtual-machines-backup'
            )
            .then((result) => {
                return result ? this.backupVirtualMachines(this.chosenVirtualMachines) : result;
            })
            .then(
                () => { },
                (err) => (this.err = err)
            );
    }
    backupVirtualMachines(vms) {
        let data = [];
        for (let i = 0; i < vms.length; i++) {
            data.push(vms[i].uuid);
        }
        this.crudService.post('backups', data).then((resp) => {
            this.notificationService.pop(resp.data.message);
            this.$timeout(() => {
                if (this.shownDetailsIndex) {
                    this.persistence
                        .showBackups(this.shownDetailsIndex, this.dateFilter, true)
                        .then((restorePoints) => {
                            this.restorePoints = restorePoints;
                        });
                }
            }, 3000);
        });
    }
    configVirtualMachinesTable() {
        this.columnNames = [
            this.$filter('translate')('vm.table.header.name'),
            this.$filter('translate')('vm.table.header.resourceGroup'),
            this.$filter('translate')('vm.table.header.location'),
            this.$filter('translate')('vm.table.header.policy'),
            this.$filter('translate')('vm.table.header.compliancy'),
            this.$filter('translate')('vm.table.header.status'),
            this.$filter('translate')('vm.table.header.discovery'),
            this.$filter('translate')('vm.table.header.credentialGroup'),
        ];
        if (this.isBackupAdmin) {
            this.columnNames.push(this.$filter('translate')('vm.table.header.owner'));
        }
    }
    refresh(firstPage) {
        this.refreshVirtualMachines(firstPage);
        this.persistence.initDropdownFilters();
    }
    refreshVirtualMachines(firstPage, forceSync, onReselect) {
        this.busy = true;
        return this.persistence
            .getVirtualMachines(firstPage, this.persistence.filters, forceSync)
            .then(
                (resp) => {
                    this.virtualMachines = resp;
                    let tempItems = [],
                        tempUuid = null;
                    this.virtualMachines.forEach((virtualMachine) => {
                        virtualMachine.policy = virtualMachine.policy ? virtualMachine.policy : '';
                        virtualMachine.credential = virtualMachine.credential ? virtualMachine.credential : '';
                        this.chosenVirtualMachines.forEach((chosenVm, index) => {
                            if (!onReselect) {
                                if (
                                    chosenVm.uuid === virtualMachine.uuid ||
                                    chosenVm.uuid === virtualMachine.hycuRestoreUuid
                                ) {
                                    virtualMachine._selected = true;
                                    this.chosenVirtualMachines[index] = virtualMachine;
                                    this.setChosenVirtualMachines(this.chosenVirtualMachines);
                                }
                            }
                            // NOTE: on reselect HYCU uuid for each vm is changed, so we have to handle it on different way
                            else {
                                if (
                                    chosenVm.uuid === virtualMachine.uuid ||
                                    chosenVm.uuid === virtualMachine.hycuRestoreUuid
                                ) {
                                    this.chosenVirtualMachines[index] = virtualMachine;
                                    tempItems.push(virtualMachine);
                                    if (this.shownDetailsIndex && chosenVm.uuid === this.shownDetailsIndex.id) {
                                        tempUuid = virtualMachine.uuid;
                                    }
                                }
                            }
                        });
                    });
                    if (this.shownDetailsIndex && !tempUuid) {
                        let showD = this.virtualMachines.filter(
                            (item) =>
                                item.uuid === this.shownDetailsIndex.id ||
                                item.hycuRestoreUuid === this.shownDetailsIndex.id
                        )[0];
                        if (!showD) {
                            this.shownDetailsIndex = false;
                        } else {
                            this.showDetails(this.chosenVirtualMachines[0], true);
                        }
                    }
                    if (onReselect) return { detailedUuid: tempUuid, existingItems: tempItems };
                    this.busy = false;
                },
                (err) => {
                    this.busy = false;
                    this.virtualMachines = [];
                    this.chosenVirtualMachines = [];
                    this.shownDetailsIndex = false;
                }
            )
            .finally(() => {
                return this.persistence
                    .getAllVirtualMachines()
                    .then((res) => {
                        this.allVms = res;
                    })
                    .finally(() => {
                        return this.$timeout(() => (this.busy = false), 0);
                    });
            });
    }
    hardRefreshVM() {
        this.busy = true;
        this.crudService.get('virtualMachines/synchronize').then(
            (res) => { },
            (err) => {
                this.busy = false;
            }
        );
    }
    filterRefresh() {
        this.refresh(true);
        this.filterFlag++;
        this.$window.onresize = undefined;
        this.shownDetailsIndex = false;
    }
    reselectVirtualMachines() {
        return this.refreshVirtualMachines(null, null, true).then((res) => {
            let items = res.existingItems.map((i) => i.uuid);
            let others = this.chosenVirtualMachines.filter((i) => items.indexOf(i.uuid) < 0).map((i) => i.externalId);
            this.chosenVirtualMachines = this.chosenVirtualMachines.filter((i) => items.indexOf(i.uuid) >= 0);
            return this.basePrepare(res.detailedUuid, others).then(() => {
                this.chosenVirtualMachines.forEach((vm) => (vm._selected = true));
                return this.chosenVirtualMachines;
            });
        });
    }
    basePrepare(uuid, others) {
        let promises = [];
        others.forEach((item) => {
            let deffered = this.$q.defer();
            this.crudService
                .get('vms?' + this.crudService.getSearchQuery('externalId', item))
                .then((res) => {
                    let item = res.data.items.map(VirtualMachine.fromRaw)[0];
                    this.chosenVirtualMachines.push(item);
                    deffered.resolve(res);
                })
                .catch((error) => {
                    deffered.resolve(error);
                });
            promises.push(deffered.promise);
        });
        return this.$q.all(promises).then(() => {
            return this.initialize(uuid);
        });
    }
    initialize(uuid) {
        this.chosenVirtualMachines.forEach((vm) => (vm._selected = true));
        if (this.shownDetailsIndex && uuid) {
            let tempDetails = this.chosenVirtualMachines.filter((item) => item.uuid === uuid)[0];
            if (!tempDetails) this.shownDetailsIndex = false;
            else {
                this.showDetails(tempDetails, true);
            }
        }
        this.busy = false;
        return this.chosenVirtualMachines;
    }
    showDetails(item, refresh) {
        if (!item) {
            this.shownDetailsIndex = false;
            this.restorePoints = [];
            this.selectedRestorePoint = [];
            this.flrLabel = this.$filter('translate')('vm.subTable.detail.actionRestoreFiles.label');
            this.$window.onresize = undefined;
            if (tagsUnwatch) tagsUnwatch();
            return;
        }
        if (!refresh && item._selected && this.shownDetailsIndex && this.shownDetailsIndex.id === item.uuid) {
            return;
        }
        this.shownDetailsIndex = item._selected ? { id: item.uuid, name: item.name } : false;
        this.restorePoints = [];
        this.selectedRestorePoint = [];
        if (this.shownDetailsIndex) {
            // this.checkForRunningFlr();
            this.busyBackups = true;
            this.detaildVirtualMachine = item;
            this.persistence
                .setVirtualMachineDetails(item)
                .then((virtualMachine) => this.setVirtualMachineDetails(virtualMachine));
            this.persistence.showBackups(this.shownDetailsIndex, this.dateFilter, true).then((restorePoints = []) => {
                if (restorePoints[0] && this.shownDetailsIndex.id === restorePoints[0].virtualMachinesubscriptionId) {
                    this.restorePoints = restorePoints;
                    this.$timeout(() => {
                        if (this.restorePoints.length) this.selectedRestorePoint[0] = this.restorePoints[0];
                        this.$timeout(() => {
                            let tempEl = this.$element.find('.details-view').find('tbody')[0];
                            if (tempEl) {
                                this.ctxGridMinOverflow = tempEl.getBoundingClientRect().top;
                                this.ctxGridMaxOverflow = tempEl.getBoundingClientRect().bottom;
                            }
                        }, 500);
                    }, 0);
                    // on resize reset grid max overflow
                    let resizeEv;
                    this.$window.onresize = () => {
                        if (resizeEv) clearTimeout(resizeEv);
                        resizeEv = setTimeout(() => {
                            this.ctxGridMinOverflow = this.$element
                                .find('.details-view')
                                .find('tbody')[0]
                                .getBoundingClientRect().top;
                            this.ctxGridMaxOverflow = this.$element
                                .find('.details-view')
                                .find('tbody')[0]
                                .getBoundingClientRect().bottom;
                        }, 150);
                    };
                    this.busyBackups = false;
                } else {
                    this.busyBackups = false;
                }
            });
            this.configureRestorePointTable();
            if (tagsUnwatch) tagsUnwatch();
            tagsUnwatch = this._$scope.$watch(
                () => this.$element.find('.backups-restore-point').width(),
                (width) => {
                    this.oneLetterTags = width && width < 350;
                }
            );
        } else {
            if (tagsUnwatch) tagsUnwatch();
            this.flrLabel = this.$filter('translate')('vm.subTable.detail.actionRestoreFiles.label');
            this.$window.onresize = undefined;
        }
    }
    refreshBackups(firstPage) {
        this.busyBackups = true;
        this.persistence
            .showBackups(this.shownDetailsIndex, this.dateFilter, firstPage)
            .then((res) => {
                this.restorePoints = res;
            })
            .finally(() => {
                this.busyBackups = false;
                this.backupFilterFlag++;
                this.selectedRestorePoint[0] = this.restorePoints ? this.restorePoints[0] : null;
            });
    }
    checkForRunningFlr() {
        this.disableFlr = true;
        this.persistence.isFlr(this.chosenVirtualMachines[0].name).then((res) => {
            this.disableFlr = false;
            this.flrTaskId = res.taskId;
            this.discoveryStatus = res.discoveryStatus;
        });
    }
    setVirtualMachineDetails(virtualMachine) {
        if (!virtualMachine.vmStatus && virtualMachine.protection === 'PROTECTED_DELETED') {
            virtualMachine.vmStatus = 'Deleted';
        }

        this.selectedVirtualMachine = virtualMachine;
        this.virtualMachineDetailsName = this.selectedVirtualMachine.name;
        this.virtualMachineDetails = [
            {
                detail: this.$filter('translate')('vm.subTable.detail.vmUuid.label'),
                value: virtualMachine.uuid,
                icon: 'icon-copy',
                id: 'vm-uuid',
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.virtualMachineId.label'),
                value: virtualMachine.name,
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.vmType.label'),
                value: virtualMachine.machineType,
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.cpuPlatform.label'),
                value: virtualMachine.cpuPlatform,
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.machineType.label'),
                value: virtualMachine.sizeAzure,
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.OSType.label'),
                value: virtualMachine.operatingSystem,
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.virtualMachineStatus.label'),
                value: virtualMachine.vmStatus,
                class: this.setStatusLabelClass(virtualMachine),
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.status.label'),
                value: virtualMachine.taskStatus,
                class:
                    virtualMachine.taskStatus === 'RUNNING'
                        ? 'status-green'
                        : virtualMachine.taskStatus === 'TERMINATED'
                            ? 'status-red'
                            : '',
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.location.label'),
                value: virtualMachine.location.displayName,
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.privateIp.label'),
                value: virtualMachine.privateIps.length > 0 ? virtualMachine.privateIps.join(', ') : '/',
                icon: virtualMachine.privateIps.length > 0 ? 'icon-copy' : null,
                id: 'vm-private-ip',
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.publicIp.label'),
                value: virtualMachine.publicIps.length > 0 ? virtualMachine.publicIps.join(', ') : '/',
                icon: virtualMachine.publicIps.length > 0 ? 'icon-copy' : null,
                id: 'vm-public',
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.virtualMachineSize.label'),
                value: this.utilsService.fromBytesTo(virtualMachine.sizeB, 'gib') + ' GiB',
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.diskCount.label'),
                value: virtualMachine.disksCount,
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.timeSinceLastBackup.label'),
                value: virtualMachine.timeSinceLastSuccessfulBackup
                    ? this.utilsService.formatTime(virtualMachine.timeSinceLastSuccessfulBackup)
                    : 0 + ' s',
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.backupSuccessRate.label'),
                value: parseFloat((virtualMachine.backupSuccessRate * 100).toFixed(2)) + ' %',
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.policyComplianceSuccessRate.label'),
                value: parseFloat((virtualMachine.policyCompliancySuccessRate * 100).toFixed(2)) + ' %',
            },
            {
                detail: this.$filter('translate')('vm.subTable.detail.policyAssignor.label'),
                value:
                    virtualMachine.policyAssignor && virtualMachine.policyAssignor.identifier
                        ? virtualMachine.policyAssignor.identifier
                        : null,
            },
        ];
    }
    assignPolicy(policy) {
        const array = this.chosenVirtualMachines.map((virtualMachine) => virtualMachine.uuid);
        return this.persistence
            .assignVirtualMachinePolicy(policy, array)
            .then((resp) => {
                this.notificationService.pop(resp.data.message);
            })
            .finally(() => {
                this.showPoliciesDialog = false;
                this.refresh();
                this.$timeout(() => {
                    if (this.shownDetailsIndex) {
                        this.persistence
                            .showBackups(this.shownDetailsIndex, this.dateFilter, true)
                            .then((restorePoints) => {
                                this.restorePoints = restorePoints;
                            });
                    }
                }, 1500);
            });
    }
    unassignPolicy(policy) {
        let virtualMachines = this.chosenVirtualMachines.map((virtualMachine) => virtualMachine.uuid);
        return this.persistence
            .unassignVirtualMachinePolicy(policy, virtualMachines)
            .then((resp) => {
                this.notificationService.pop(resp.data.message);
            })
            .finally(() => {
                this.showPoliciesDialog = false;
                this.refresh();
            });
    }
    unassignCred(credentials) {
        let virtualMachines = this.chosenVirtualMachines.map((virtualMachine) => virtualMachine.uuid);
        return this.persistence
            .unassignCredGroup(credentials, virtualMachines)
            .then((resp) => {
                this.notificationService.pop(resp.data.message);
            })
            .finally(() => {
                this.showCredentialsDialog = false;
                // this.refresh();
                this.reselectVirtualMachines();
            });
    }
    openVmConfigurationDialog() {
        if (this.chosenVirtualMachines.length > 1) {
            this.showMultiVmConfigurationDialog = true;
        } else {
            this.showVmConfigurationDialog = true;
        }
    }
    setGrid(grid) {
        this.grid = grid;
        this.ctxGridStyleConfig = {
            multiselect: true,
            columnsWidthMapInPct: [],
        };
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('2%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('20%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('15%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('12%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('10%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('9%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('9%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('10%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('13%');
        this.$timeout(() => {
            this.grid.tableName = this.grid.tableName + '-' + this.storageService.getUsername();
            if (angular.isDefined(this.storageService.getGridWolumnsWidthMapInPct(this.grid.tableName))) {
                this.ctxGridStyleConfig.columnsWidthMapInPct = this.storageService.getGridWolumnsWidthMapInPct(
                    this.grid.tableName
                );
            }
            this.gridColumnsStyleConfig = this.ctxGridStyleConfig;
            this.gridFlag = true;
        }, 0);
    }
    configureRestorePointTable() {
        this.restorePointsTableConfig = [
            {
                name: this.$filter('translate')('vm.subTable.detail.restorePoint.label'),
                key: 'restorePointInMillis',
            },
            { name: this.$filter('translate')('vm.subTable.detail.compliancy.label'), key: 'compliancy' },
            { name: this.$filter('translate')('vm.subTable.detail.backupStatus.label'), key: 'status' },
            { name: this.$filter('translate')('vm.subTable.detail.restoreStatus.label'), key: 'restoreStatus' },
        ];
    }
    flRestore() {
        this.selectedVersion = this.selectedRestorePoint[0];
        this.showRecoverFile = true;
    }
    virtualMachineRestore() {
        this.selectedVersion = this.selectedRestorePoint[0];
        this.showRecoverVm = true;
    }
    expireBackup() {
        this.selectedVersion = this.selectedRestorePoint[0];
        this.showExpireModal = true;
    }
    deleteSnapshot(tiers) {
        let selectedTiers = tiers;
        let selectedVersion = this.selectedRestorePoint[0];
        if (!selectedVersion) return;
        let filteredTiers = this.selectedVersion.backupTiers.filter((item) => item.state !== 'EXPIRED');
        if (filteredTiers.length > 1) {
            this.disableExpireDialogInteraction = true;
            this.dialogService
                .showYesNo(
                    selectedVersion.taskStatus === 'FATAL'
                        ? this.$filter('translate')('vm.dialog.expireBackup.statusFatal.message')
                        : this.$filter('translate')('vm.dialog.expireBackup.statusOk.message'),
                    this.$filter('translate')('vm.dialog.expireBackup.title'),
                    null,
                    'virtual-machine-delete-backup'
                )
                .then((result) => {
                    if (!result) {
                        this.disableExpireDialogInteraction = false;
                        return;
                    } else {
                        this.runExpire(selectedVersion, selectedTiers);
                    }
                });
        } else {
            this.runExpire(selectedVersion, selectedTiers);
        }
    }
    runExpire(selectedVersion, selectedTiers) {
        this.expireBusy = true;
        this.persistence
            .deleteBackup(selectedVersion.uuid, selectedTiers)
            .then(
                (resp) => {
                    this.notificationService.pop(resp.data.message);
                    this.persistence
                        .showBackups(this.shownDetailsIndex, this.dateFilter, false)
                        .then((restorePoints) => {
                            this.restorePoints = restorePoints;
                        })
                        .finally(() => {
                            this.selectedRestorePoint = [];
                            this.disableExpireDialogInteraction = false;
                            this.expireBusy = false;
                        });
                },
                (err) => {
                    this.notificationService.pop({
                        type: 'error',
                        titleDescription: err.data.error.message,
                    });
                    this.disableExpireDialogInteraction = false;
                    this.expireBusy = false;
                }
            )
            .finally(() => {
                this.showExpireModal = false;
                this.expireBusy = false;
                this.disableExpireDialogInteraction = false;
            });
    }
    setSubGrid(grid) {
        this.detailsGrid = grid;
        this.ctxDetailsGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: [],
        };
        this.ctxDetailsGridStyleConfig.columnsWidthMapInPct.push('51%');
        this.ctxDetailsGridStyleConfig.columnsWidthMapInPct.push('15%');
        this.ctxDetailsGridStyleConfig.columnsWidthMapInPct.push('17%');
        this.ctxDetailsGridStyleConfig.columnsWidthMapInPct.push('17%');
        this.$timeout(() => {
            this.detailsGrid.tableName = this.detailsGrid.tableName + '-' + this.storageService.getUsername();
            if (angular.isDefined(this.storageService.getGridWolumnsWidthMapInPct(this.detailsGrid.tableName))) {
                this.ctxDetailsGridStyleConfig.columnsWidthMapInPct = this.storageService.getGridWolumnsWidthMapInPct(
                    this.detailsGrid.tableName
                );
            }
            this.detailsGridColumnsStyleConfig = this.ctxDetailsGridStyleConfig;
            this.detailsGridFlag = true;
        }, 0);
    }

    setStatusLabelClass(virtualMachine) {
        if (!virtualMachine.vmStatus) {
            return;
        }

        if (virtualMachine.vmStatus.toUpperCase() === 'VM RUNNING') {
            return 'status-green';
        } else if (
            virtualMachine.vmStatus.toUpperCase() === 'VM DEALLOCATED' ||
            virtualMachine.vmStatus.toUpperCase() === 'VM STOPPED'
        ) {
            return 'status-yellow';
        } else if (
            virtualMachine.vmStatus.toUpperCase() === 'DELETED' &&
            virtualMachine.protection === 'PROTECTED_DELETED'
        ) {
            return 'status-red';
        } else {
            return '';
        }
    }

    goToRelatedJob(jobUuid) {
        if (!jobUuid) return;
        this.$timeout(() => {
            this.$state.go('app.jobs', { jobUuid: jobUuid });
        }, 200);
    }
    openFilter(filterType, closeFilter, updateFilter) {
        this[filterType] = !this[filterType];
        this.showFilterOptions = this[filterType];
        this[closeFilter] = false;
        // if (updateFilter) this.persistence.updateFilters(this.isBackupAdmin, this.isAdmin);
    }
    showFilters() {
        if (this.backups && !this.shownDetailsIndex) {
            this.backups = !this.backups;
            this.mainFilters = !this.mainFilters;
            this.vmTitle = null;
        }
        return this.backups ? this.persistence.backupFilters : this.persistence.filters;
    }
    onExport(type) {
        this.busy = true;
        return this.persistence[type === 'all' ? 'getAllVirtualMachines' : 'getVirtualMachines'](
            null,
            this.persistence.filters,
            null,
            { isExport: true }
        )
            .then((res) => {
                return res.map((item) => {
                    let result = {};
                    result['name'] = item.name;
                    result['resourceGroup'] = item.resourceGroup;
                    result['location'] = item.location.name;
                    result['policyName'] = !item.policy ? '' : item.policy;
                    result['complianceStatus'] = !item.compliancy ? '' : item.compliancy;
                    result['protection'] = !item.protection ? '' : item.protection;
                    result['credential'] = !item.credential ? '' : item.credential;
                    return result;
                });
            })
            .finally(() => {
                this.busy = false;
            });
    }
    setPolicyTooltip() {
        if (
            this.chosenVirtualMachines.length &&
            this.chosenVirtualMachines.filter((item) => item.policyAssignedFromTags === false).length < 1
        ) {
            return this.$filter('translate')('vm.toolbar.policies.hasTags');
        }
    }
    disableExpiredAction() {
        return (
            !this.hasExpirePermissions() ||
            !this.selectedRestorePoint ||
            !this.selectedRestorePoint[0] ||
            !this.selectedRestorePoint[0].expireAvailable ||
            this.selectedRestorePoint[0].lastRestoreStatus === 'RUNNING' ||
            this.selectedRestorePoint[0].uuid === null
        );
    }
    disableAction() {
        return (
            !this.selectedRestorePoint ||
            !this.selectedRestorePoint[0] ||
            this.restorePoints.filter(
                (item) =>
                    item.uuid === this.selectedRestorePoint[0].uuid &&
                    item.taskStatus !== 'OK' &&
                    item.taskStatus !== 'WARNING' &&
                    item.taskStatus !== 'ERROR'
            ).length
        );
        // ((item.protection !== 'OK' && item.protection !== 'WARNING' && item.protection !== 'ERROR') || item.snapshots.filter(ss => ss.status === 'IN_PROGRESS' || ss.status === 'IN_USE')[0])).length;
    }
    disableVirtualMachineRestore() {
        return (
            !this.hasRestorePermissions() ||
            !this.selectedRestorePoint ||
            !this.selectedRestorePoint[0] ||
            !this.selectedRestorePoint[0].restoreAvailable ||
            this.disableFlr ||
            (this.restorePoints &&
                this.restorePoints.filter((item) => item.lastRestoreStatus && item.lastRestoreStatus === 'RUNNING')
                    .length)
        );
        // ((item.protection !== 'OK' && item.protection !== 'WARNING') || item.snapshots.filter(ss => ss.status === 'IN_PROGRESS' || ss.status === 'IN_USE')[0])).length;
    }
    disableVirtualMachineFlrRestore() {
        if (this.selectedRestorePoint[0] && this.selectedRestorePoint[0].disks) {
            let allCatalogsNull = true;
            this.selectedRestorePoint[0].disks.forEach((disk) => {
                if (disk.catalog !== null) {
                    allCatalogsNull = false;
                }
            });
            if (allCatalogsNull) {
                return true;
            }
        }

        return (
            !this.hasRestoreFilesPermissions() ||
            !this.selectedRestorePoint ||
            !this.selectedRestorePoint[0] ||
            !this.selectedRestorePoint[0].catalogsAvailable ||
            !this.selectedRestorePoint[0].restoreFlrAvailable ||
            this.disableFlr
        );
    }
    disableBackup() {
        return (
            !this.hasBackupPermissions() ||
            !this.chosenVirtualMachines ||
            !this.chosenVirtualMachines.length ||
            this.chosenVirtualMachines.filter((item) => item.protection === VM_PROTECTED_DELETED).length ||
            this.chosenVirtualMachines.filter((v) => v.policy).length !== this.chosenVirtualMachines.length ||
            this.chosenVirtualMachines.filter((v) => v.policy === 'Exclude').length ||
            (this.restorePoints && this.restorePoints.filter((item) => item.taskStatus === 'RUNNING').length)
        );
    }
    disableEdit() {
        return (
            !this.hasPoliciesPermissions() ||
            !this.chosenVirtualMachines ||
            !this.chosenVirtualMachines.length ||
            this.busy ||
            this.chosenVirtualMachines.filter((item) => item.protection === VM_PROTECTED_DELETED).length ||
            this.chosenVirtualMachines.filter((item) => item.policyAssignedFromTags === false).length < 1
        );
    }
    disableConfiguration() {
        return (
            !this.chosenVirtualMachines ||
            !this.chosenVirtualMachines.length ||
            this.busy ||
            this.chosenVirtualMachines.filter((item) => item.status === VM_PROTECTED_DELETED).length >= 1 ||
            !this.hasConfigurationPermissions()
        );
    }
    disableCredentials() {
        return (
            !this.hasCredentialsPermissions() ||
            (this.chosenVirtualMachines &&
                this.chosenVirtualMachines.length > 0 &&
                this.chosenVirtualMachines.filter((item) => item.ostype === 'LINUX').length > 0)
        );
    }
    hasVmListingPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.VM_LISTING);
    }
    hasRestorePermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.VM_RESTORE);
    }
    hasRestoreFilesPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.VM_FILE_RESTORE);
    }
    hasExpirePermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.VM_BACKUP_EXPIRE);
    }
    hasConfigurationPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.VM_CONFIGURATION);
    }
    hasPoliciesPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.VM_POLICY);
    }
    hasCredentialsPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.VM_CREDENTIALS_ASSIGN);
    }
    hasBackupPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.VM_BACKUP_START);
    }
}
VirtualMachinesController.$inject = [
    '$scope',
    '$timeout',
    '$element',
    '$window',
    '$filter',
    '$stateParams',
    '$state',
    '$q',
    '$rootScope',
    'crudService',
    'utilsService',
    'dialogService',
    'notificationService',
    'virtualMachinesPersistence',
    'storageService',
    'sharedPersistenceService',
    'recoverFileService',
    'iamPersistenceService',
];
const virtualMachinesComponent = {
    controller: VirtualMachinesController,
    template: require('./virtualMachines.template.html'),
    bindings: {
        numOfShowVms: '<',
        startingPage: '<',
    },
};
module.exports = virtualMachinesComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/virtualMachines/virtualMachines.component.js